import { render, staticRenderFns } from "./back-top-ercode.vue?vue&type=template&id=f7698882&scoped=true&lang=pug&"
import script from "./back-top-ercode.vue?vue&type=script&lang=js&"
export * from "./back-top-ercode.vue?vue&type=script&lang=js&"
import style0 from "./back-top-ercode.vue?vue&type=style&index=0&id=f7698882&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7698882",
  null
  
)

export default component.exports